<script setup lang="ts">
  import { computed } from 'vue'

  defineProps<{
    label?: string,
    error?: string | string[],
    autocomplete?: string,
    required?: boolean,
    placeholder?: string,
    disabled?: boolean,
  }>()

  const model = defineModel<string>({ required: true })

  const number = computed({
    get: () => removeNonNumeric(model.value),
    set: (val: string) => model.value = `+62${val}`,
  })

  const removeNonNumeric = (value: string) => value
    .replace(/\D/g, '')
    .replace(/^0/, '')
    .replace(/^628/, '8')
</script>

<template>
  <app-input
    v-model="number"
    type="tel"
    :tabindex="2"
    :label="label"
    :autocomplete="autocomplete"
    :placeholder="placeholder"
    :required="required"
    :max-length="13"
    :disabled="disabled"
    :error="error">
    <template #inline>
      <div class="order-first text-xs px-2 bg-gray-200 h-[var(--h-input)] flex items-center rounded-l">
        +62
      </div>
    </template>
  </app-input>
</template>

<style scoped>
  @reference "@/assets/styles/main.css";

  :deep(input) {
    @apply rounded-l-none;
  }
</style>
